import React from "react";
import { Link } from "react-router-dom";

import lockupWhite from "../../assets/wmu-lockup-white.svg";

export default function Header() {
  return (
    <header className="Site-header">
      <Link to="/" className="Site-header-logo">
        <img src={ lockupWhite } alt="what's my uprn?" />
      </Link>
      <Link to="/" className="Site-header-link">Search another address</Link>
    </header>
  );
}
